import { LOCATION_CHANGE } from 'react-router-redux';
import { handleActions } from 'redux-actions';
import actions from './actions';

export const initialState = {
  publisher: {
    publishers: [],
    isFetching: false,
    error: null
  }
};

const extendState = (state, newState) => ({
  ...state,
  publisher: {
    ...state.publisher,
    ...newState
  }
});

export const reducerDefinition = {
  [actions.publisherPortal.publishers.api.get.request]: (state, action) =>
    extendState(state, {
      publishers: [],
      isFetching: true
    }),
  [actions.publisherPortal.publishers.api.get.success]: (state, action) =>
    extendState(state, {
      isFetching: false,
      publishers: action.payload.publishers,
      error: null
    }),
  [actions.publisherPortal.publishers.api.get.failed]: (state, action) =>
    extendState(state, {
      isFetching: false,
      error: action.payload.error
    }),
  [LOCATION_CHANGE]: (state, action) => ({
    ...state,
    publisher: {
      isFetching: false,
      error: null
    },
    publishedEvent: {
      isFetching: false,
      eventToUpdate: undefined
    }
  })
};

export default handleActions(reducerDefinition, { ...initialState });



// WEBPACK FOOTER //
// ./src/state/modules/publisher-portal/publisher/reducers.js